module.exports = __webpack_public_path__ + "static/media/Full_pred_vs_BuyNHold.1ea2c457.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Full_pred_vs_BuyNHold.png
// module id = 90
// module chunks = 0